/* Sections de conviction de la fiche produit (préfixe hx-).
   Chargé par plusieurs sections : la garde ci-dessous évite une double
   initialisation. Chaque module s'initialise sur son conteneur et se
   ré-initialise quand l'éditeur de thème recharge une section. */
(function () {
  'use strict';
  if (window.__hxSections) return;
  window.__hxSections = true;

  /* ---------- Cinq chambres ----------
     Chronologie d'un cycle en « temps appareil » (5,6 s) : la chambre i
     (0 = pied … 4 = cuisse) gonfle à i × 0,5 s en 0,55 s, tient jusqu'à R[i],
     relâche en 0,7 s. L'affichage est ralenti (× 0,22) pour laisser lire. */
  const CYCLE = 5.6;
  const START = [0, 0.5, 1, 1.5, 2];
  const RELEASE = [3.4, 3.62, 3.84, 4.06, 4.28];
  const RISE = 0.55;
  const FALL = 0.7;
  const SLOW = 0.22;
  const GEO = [{ y: 330, h: 56 }, { y: 270, h: 52 }, { y: 190, h: 72 }, { y: 126, h: 56 }, { y: 30, h: 88 }];
  const PARTICLES = 36;

  const ease = (x) => (x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2);
  const cycleTime = (T) => ((T % CYCLE) + CYCLE) % CYCLE;

  function pressure(i, T) {
    const t = cycleTime(T);
    if (t < START[i]) return 0;
    if (t < START[i] + RISE) return ease((t - START[i]) / RISE);
    if (t < RELEASE[i]) return 1;
    if (t < RELEASE[i] + FALL) return 1 - ease((t - RELEASE[i]) / FALL);
    return 0;
  }

  function initChambers(root) {
    if (root.dataset.hxReady) return;
    root.dataset.hxReady = '1';

    const leg = root.querySelector('[data-hx-leg]');
    if (!leg) return;
    const chambers = [0, 1, 2, 3, 4].map((i) => {
      const w = leg.querySelector('[data-hx-w="' + i + '"]');
      return {
        w,
        fill: w && w.querySelector('[data-hx-fill]'),
        glow: w && w.querySelector('[data-hx-glow]'),
        name: leg.querySelector('[data-hx-name="' + i + '"]'),
      };
    });
    const caps = Array.from(root.querySelectorAll('[data-hx-cap]'));
    const segs = Array.from(root.querySelectorAll('[data-hx-seg]'));
    const wave = leg.querySelector('[data-hx-wave]');

    const firstName = leg.querySelector('.hx-ch-name');
    const dots = [];
    for (let i = 0; i < PARTICLES; i++) {
      const d = document.createElement('span');
      d.className = 'hx-ch-pt';
      leg.insertBefore(d, firstName);
      dots.push(d);
    }

    let lastStep = -1;
    function render(realT) {
      const T = realT * SLOW;
      const t = cycleTime(T);
      const P = chambers.map((_, i) => pressure(i, T));

      let step = 0;
      for (let i = 0; i < 5; i++) if (t >= i * 0.5) step = i;
      if (t >= RELEASE[0]) step = 5;

      let front = 386;
      P.forEach((v, i) => {
        if (v > 0.01) front = Math.min(front, GEO[i].y + GEO[i].h * (1 - v));
      });

      chambers.forEach((c, i) => {
        const v = P[i];
        if (c.fill) c.fill.style.height = v * 100 + '%';
        if (c.glow) c.glow.style.opacity = String(v * 0.55);
        if (c.w) c.w.style.transform = 'scaleX(' + (1 + 0.055 * v) + ')';
        if (c.name) c.name.style.opacity = String(0.3 + 0.7 * v);
      });

      if (step !== lastStep) {
        caps.forEach((el, k) => {
          el.classList.toggle('is-on', k === step);
          el.classList.toggle('is-past', k < step);
        });
        lastStep = step;
      }

      segs.forEach((el, k) => {
        const st = k < 5 ? k * 0.5 : RELEASE[0];
        const en = k < 5 ? st + 0.5 : CYCLE;
        const f = Math.max(0, Math.min(1, (t - st) / (en - st)));
        el.style.width = (k < 5 && t >= RELEASE[0] ? 100 : f * 100) + '%';
      });

      if (wave) {
        const op = t < RELEASE[0] ? Math.min(1, t / 0.3) : Math.max(0, 1 - (t - RELEASE[0]) / 0.8);
        wave.style.top = front - 30 + 'px';
        wave.style.opacity = String(front < 386 ? op : 0);
      }

      // Les particules montent en temps réel (non ralenti).
      dots.forEach((el, i) => {
        const x = 74 + ((i * 37) % 82) + Math.sin(realT * 1.3 + i) * 3;
        const y = 384 - ((realT * (22 + (i % 5) * 5) + ((i * 97) % 354)) % 354);
        let c = -1;
        for (let j = 0; j < 5; j++) if (y >= GEO[j].y && y <= GEO[j].y + GEO[j].h) c = j;
        el.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px)';
        el.style.opacity = String(c < 0 ? 0.05 : 0.06 + 0.75 * P[c]);
      });
    }

    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      root.classList.add('is-static');
      render(2.8 / SLOW); // toutes les chambres pleines
      return;
    }

    let T = 0;
    let last = 0;
    let raf = 0;
    let visible = false;

    function loop(now) {
      const dt = last ? Math.min(0.1, (now - last) / 1000) : 0;
      last = now;
      T += dt;
      render(T);
      raf = visible ? requestAnimationFrame(loop) : 0;
    }

    render(0);
    if (!('IntersectionObserver' in window)) {
      visible = true;
      raf = requestAnimationFrame(loop);
      return;
    }
    new IntersectionObserver((entries) => {
      visible = entries[0].isIntersecting;
      if (visible && !raf) {
        last = 0;
        raf = requestAnimationFrame(loop);
      }
    }).observe(root);
  }

  /* ---------- Le vrai calcul ---------- */
  function formatEuros(n) {
    return n.toLocaleString('fr-FR') + ' €';
  }

  function initCalc(root) {
    if (root.dataset.hxReady) return;
    root.dataset.hxReady = '1';

    const range = root.querySelector('[data-hx-range]');
    const bars = Array.from(root.querySelectorAll('[data-hx-bars] span'));
    const boots = Number(root.dataset.boots);
    const maxPrice = Number(root.dataset.max);
    if (!range || !bars.length || !(boots > 0) || !(maxPrice > 0)) return;

    const maxTotal = bars.length * maxPrice;
    const priceLabels = root.querySelectorAll('[data-hx-price-label]');
    const annual = root.querySelector('[data-hx-annual]');
    const savings = root.querySelector('[data-hx-savings]');
    const be = root.querySelector('[data-hx-be]');
    const beN = root.querySelector('[data-hx-be-n]');

    function update() {
      const price = Number(range.value);
      if (!(price > 0)) return;
      const breakEven = Math.ceil(boots / price);
      bars.forEach((el, i) => {
        el.style.height = (((i + 1) * price) / maxTotal * 100).toFixed(2) + '%';
        el.classList.toggle('is-paid', i + 1 >= breakEven);
      });
      priceLabels.forEach((el) => { el.textContent = price + ' €'; });
      if (annual) annual.textContent = formatEuros(bars.length * price);
      if (savings) savings.textContent = formatEuros(bars.length * price - boots);
      if (beN) beN.textContent = String(breakEven);
      if (be) {
        const left = breakEven <= 26;
        be.style.left = (((breakEven - 0.5) / bars.length) * 100).toFixed(2) + '%';
        be.style.bottom = ((breakEven * price) / maxTotal * 100).toFixed(2) + '%';
        be.style.alignItems = left ? 'flex-start' : 'flex-end';
        be.style.transform = left ? 'translate(-1px,-14px)' : 'translate(calc(-100% + 1px),-14px)';
      }
    }

    range.addEventListener('input', update);
    update();
  }

  /* ---------- Pour qui ---------- */
  function initWho(root) {
    if (root.dataset.hxReady) return;
    root.dataset.hxReady = '1';

    const items = Array.from(root.querySelectorAll('[data-hx-who-item]'));
    const cards = Array.from(root.querySelectorAll('[data-hx-who-card]'));
    items.forEach((item, i) => {
      const btn = item.querySelector('[data-hx-who-btn]');
      if (!btn) return;
      btn.addEventListener('click', () => {
        items.forEach((it, k) => {
          it.classList.toggle('is-on', k === i);
          const b = it.querySelector('[data-hx-who-btn]');
          if (b) b.setAttribute('aria-expanded', k === i ? 'true' : 'false');
        });
        cards.forEach((c, k) => c.classList.toggle('is-on', k === i));
      });
    });
  }

  function initAll(scope) {
    scope.querySelectorAll('[data-hx-chambers]').forEach(initChambers);
    scope.querySelectorAll('[data-hx-calc]').forEach(initCalc);
    scope.querySelectorAll('[data-hx-who]').forEach(initWho);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target instanceof Element) initAll(e.target);
  });
})();
